module.exports = __webpack_public_path__ + "static/media/menuimage_sharing.3999005f.jpg";